import * as React from 'react';
import TracksList from '../common/TracksList';
import config from '../../config';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from '../../config/i18next';

class Tracks extends React.Component<any, any>{

    render() {
        const {t} = this.props;
        
        return (
            <div className="music_box">
                <div className="row">
                    <div className="col-md-6 col-xs-12">
                        <NavLink to="/music"><div className="title"> {t("Новые треки")} </div></NavLink>
                        <TracksList url={`${config.site}/${i18n.language}/api/track/home`} />
                        <NavLink to="/music" className="more">{t("Показать все")}</NavLink>
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div className="title">{t("Популярные треки")}</div>
                        <TracksList url={`${config.site}/${i18n.language}/api/track/home-popular`} />

                        <NavLink to="/music" className="more">{t("Показать все")}</NavLink>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Tracks);